import { render, staticRenderFns } from "./AddAdministratorForm.vue?vue&type=template&id=43529c8d"
import script from "./AddAdministratorForm.vue?vue&type=script&lang=js"
export * from "./AddAdministratorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports